import { render, staticRenderFns } from "./TillTransferToVault.vue?vue&type=template&id=1ef6ad0a&"
import script from "./TillTransferToVault.vue?vue&type=script&lang=js&"
export * from "./TillTransferToVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports